import { Translatable } from 'Shared/TranslatableTextContent/translatable'

export type ValidationTranslatableKeys = 'validationSelectAnOption' | 'validationConfirmCheckbox' | 'validationChooseADate' | 'validationUploadAFile' | 'validationEnterAResponse' | 'validationEnterBothNames' | 'validationSelectAtleastOneOption' | 'validationSelectMaximumOptions' | 'validationEmail' | 'validationPostcode' | 'validationPostcodeExpected' | 'validationPhone' | 'validationConfirmAnswers'
export const validationTranslatables: Record<ValidationTranslatableKeys, Translatable> = {
  validationSelectAnOption: {
    label: 'Select An Option',
    default: 'Please select an option',
    description: 'Validation_Select_An_Option'
  },
  validationConfirmCheckbox: {
    label: 'Confirm Checkbox',
    default: 'Please confirm by ticking the box',
    description: 'Validation_Confirm_Checkbox',
  },
  validationChooseADate: {
    label: 'Choose a Date',
    default: 'Please choose a date',
    description: 'Validation_Choose_A_Date'
  },
  validationUploadAFile: {
    label: 'Upload a File',
    default: 'Please upload a file',
    description: 'Validation_Upload_A_File'
  },
  validationEnterAResponse: {
    label: 'Enter a Response',
    default: 'Please enter a response',
    description: 'Validation_Enter_A_Response'
  },
  validationEnterBothNames: {
    label: 'Enter Both Names',
    default: 'Please enter both first and last name',
    description: 'Validation_Enter_Both_Names'
  },
  validationSelectAtleastOneOption: {
    label: 'Select at least One Option',
    default: 'Please select at least one option',
    description: 'Validation_Select_Atleast_One_OOption'
  },
  validationSelectMaximumOptions: {
    label: 'Select Maximum Options',
    default: 'Please select a maximum of {{ max_answers }} option(s)',
    description: 'Validation_Select_Maximum_Options'
  },
  validationEmail: {
    label: 'Check Email',
    default: 'Please check your email address is correct',
    description: 'Validation_Email',
  },
  validationPostcode: {
    label: 'Check Postcode',
    default: 'Please check your postcode is correct',
    description: 'Validation_Postcode',
  },
  validationPostcodeExpected: {
    label: 'Check Postcode with Example',
    default: 'Please check your postcode is correct, e.g. {{ example_postcode }}',
    description: 'Validation_Postcode_Expected',
  },
  validationPhone: {
    label: 'Check phone',
    default: 'Please check your phone number is correct',
    description: 'Validation_Phone',
  },
  validationConfirmAnswers: {
    label: 'Confirm Answers',
    default: 'Please confirm that your answers are correct',
    description: 'Validation_Confirm_Answers',
  }
} as const

export type FlowTranslatableShareKeys = 'shareTitle' | 'shareDescription' | 'shareImageUrl' | 'shareReason'
export const flowTranslatablesShare: Record<FlowTranslatableShareKeys, Translatable> = {
    shareTitle: {
        label: 'Share Title',
    },
    shareDescription: {
        label: 'Share Description',
    },
    shareImageUrl: {
        label: 'Share Image URL',
    },
    shareReason: {
        label: 'Share Reason',
        description: 'Optional message that appears before the link when sharing on WhatsApp or X',
    },
} as const

export type FlowTranslatableBaseKeys = 'buttonTextSubmit' | 'buttonTextNext' | 'selectUpToMaxAnswers' | 'questionNumberText' | 'progressPageText' | 'progressCompletedText'
export const flowTranslatablesBase: Record<FlowTranslatableBaseKeys, Translatable> = {
    buttonTextSubmit: {
        label: 'Submit Button Text',
        default: 'Submit',
    },
    buttonTextNext: {
        label: 'Next Button Text',
        default: 'Next',
    },
    selectUpToMaxAnswers: {
        label: 'Select Up To Max Answers',
        default: 'Select up to {{ max_answers }} options',
        description: 'Hint text shown above multiple select questions with a maximum answer limit'
    },
    questionNumberText: {
        label: 'Question Number Text',
        default: 'Question {{ current }} of {{ total }}',
        description: 'Text showing current question progress in surveys'
    },
    progressPageText: {
        label: 'Progress Page Text',
        default: 'Page {{ current }} of {{ total }}',
        description: 'Text showing current page in multi-page surveys'
    },
    progressCompletedText: {
        label: 'Progress Completed Text',
        default: '(completed {{ percentage }}%)',
        description: 'Text showing completion percentage in multi-page surveys'
    },
} as const

export type FlowTranslatableTemplateKeys = 'name' | 'petitionAsk' | 'petitionReason' | 'privacyText' | 'shareText' | 'eventDescription' | 'eventShortDescription' | 'eventInfoHeader' | 'ettContent' | 'introText' | 'openFormMobileButton'
export const flowTranslatableTemplates: Record<FlowTranslatableTemplateKeys, Translatable> = {
    name: {
        label: 'Pages Title',
    },
    petitionAsk: {
        label: 'Petition Ask',
        hideIfNotPresent: true,
        html: true,
    },
    petitionReason: {
        label: 'Petition Reason',
        hideIfNotPresent: true,
        html: true,
    },
    privacyText: {
        label: 'Privacy Text',
        hideIfNotPresent: true,
        html: true,
    },
    shareText: {
      label: 'Share Text',
      hideIfNotPresent: true,
    },
    eventDescription: {
        label: 'Event Description',
        hideIfNotPresent: true,
        html: true,
    },
    eventShortDescription: {
        label: 'Event Short Description',
        hideIfNotPresent: true,
        html: true,
    },
    eventInfoHeader: {
        label: 'Event Info Header',
        hideIfNotPresent: true,
    },
    ettContent: {
        label: 'ETT Content',
        hideIfNotPresent: true,
        html: true,
    },
    introText: {
        label: 'Intro Text',
        hideIfNotPresent: true,
        html: true,
    },
    openFormMobileButton: {
      label: 'Open Form Mobile Button',
      hideIfNotPresent: true,
    }
} as const

export type FlowTranslatableKeys = FlowTranslatableBaseKeys | FlowTranslatableShareKeys | FlowTranslatableTemplateKeys | ValidationTranslatableKeys
export const flowTranslatables: Record<FlowTranslatableKeys, Translatable> = {
  ...flowTranslatablesBase,
  ...flowTranslatablesShare,
  ...flowTranslatableTemplates,
  ...validationTranslatables,
} as const

